import { useAppSelector } from '@/hooks';
import { selectUserInfo } from '@/store/user';
import { useReactNativeWebView } from 'common/hooks';
import { useEffect } from 'react';
import YSF from '@neysf/qiyu-web-sdk';
import { DEFAULT_REGION } from 'common/constants';

const ContractService = () => {
  const { isReactNativeWebView, postMessage } = useReactNativeWebView();
  const userInfo = useAppSelector(selectUserInfo);
  useEffect(() => {
    if (userInfo) {
      YSF.init('3925f97a6a56d38e6bcfc741d5f60565', {
        hidden: false,
      })
        .then((ysf) => {
          ysf('config', {
            uid: String(userInfo.uniqueId),
            name: userInfo.nickName,
            mobile: `${userInfo.region || DEFAULT_REGION}-${userInfo.phone || ''}`,
            email: userInfo.email || userInfo.corpEmail || '',
          });
          ysf('open');
        })
        .catch((error) => {
          console.log('sdk加载失败---', error);
        });
    }
  }, [userInfo, isReactNativeWebView]);
  return <></>;
};
export default ContractService;
